import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import {
	FlowSheet,
	SectionFlowSheets,
	parseFlowSheetUploadResponse,
} from "../pages/sections/models/FlowSheet";

export const getFlowSheets = async (
	params: { sectionId: number; isDiagonal: boolean; billetSize: number | null },
	signal?: AbortSignal,
): Promise<SectionFlowSheets> => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "SectionId", value: params.sectionId },
		{ name: "IsDiagonal", value: params.isDiagonal },
		{ name: "BilletSize", value: params.billetSize },
	];

	const resp = await apiService.callV2(
		"[M2].[GetFlowSheets]",
		parameters,
		signal,
	);

	if (resp.ok) {
		const sizes = get(resp, "data.tables[1].rows", []) as {
			BilletSize: number;
		}[];
		return {
			drawings: get(resp, "data.tables[0].rows", []) as FlowSheet[],
			billetSizes: sizes.map((row) => row.BilletSize),
		};
	} else {
		throw new Error(resp.message || "Error fetching the stand drawings");
	}
};

export const uploadFlowSheetFile = async (file: File) => {
	const apiService = new MESApiService();
	const response: unknown = await apiService.uploadFiles([file], "flow-sheets");
	return parseFlowSheetUploadResponse(response);
};

export const upsertFlowSheet = async (params: {
	sectionId: number;
	standId: number;
	isDiagonal: boolean;
	billetSize: number | null;
	uploadFileId: number;
}) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "SectionId", value: params.sectionId },
		{ name: "StandId", value: params.standId },
		{ name: "IsDiagonal", value: params.isDiagonal },
		{ name: "BilletSize", value: params.billetSize },
		{ name: "UploadFileId", value: params.uploadFileId },
	];

	const resp = await apiService.callV2("[M2].[UpsertFlowSheet]", parameters);

	if (resp.ok) {
		return get(resp, "data.returnValue", null) as number;
	} else {
		throw new Error(resp.message || "Error saving the stand drawing");
	}
};
